module.exports = __webpack_public_path__ + "static/media/17_2.aac543ad.png";